import { sqliteTable, text, real, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// wht_certificates — หนังสือรับรองหัก ณ ที่จ่าย (50 ทวิ)
//
// สร้างเมื่อจ่ายเงินให้ supplier แล้วหักภาษี ณ ที่จ่าย
// เชื่อมกับ payment (1 payment อาจมีหลาย WHT certificate ถ้าหักหลายประเภท)
// ============================================================================
export const whtCertificates = sqliteTable("accounting_wht_certificates", {
  id: text("id").primaryKey(), // ULID
  certificateNo: text("certificate_no").notNull(), // เลขที่หนังสือรับรอง
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),

  // ผู้จ่ายเงิน (บริษัทเรา)
  payerTaxId: text("payer_tax_id"), // เลขประจำตัวผู้เสียภาษี ผู้จ่าย
  payerName: text("payer_name"), // ชื่อผู้จ่าย
  payerAddress: text("payer_address"), // ที่อยู่ผู้จ่าย
  payerBranch: text("payer_branch"), // สำนักงานใหญ่ / สาขาที่ XX

  // ผู้รับเงิน (supplier)
  payeeType: text("payee_type", {
    enum: ["individual", "company"],
  }).notNull(),
  payeeId: text("payee_id").notNull(), // FK → suppliers.id
  payeeTaxId: text("payee_tax_id"), // เลขประจำตัวผู้เสียภาษี ผู้รับ
  payeeName: text("payee_name").notNull(), // ชื่อผู้รับ
  payeeAddress: text("payee_address"), // ที่อยู่ผู้รับ

  // ข้อมูลภาษี
  whtTypeId: text("wht_type_id").notNull(), // FK → wht_types.id
  incomeDescription: text("income_description"), // รายละเอียดเงินได้
  paymentDate: text("payment_date").notNull(), // วันที่จ่ายเงิน
  incomeAmount: real("income_amount").notNull(), // จำนวนเงินที่จ่าย (ก่อนหักภาษี)
  whtRate: real("wht_rate").notNull(), // อัตราภาษี (%)
  whtAmount: real("wht_amount").notNull(), // จำนวนภาษีที่หัก
  netAmount: real("net_amount").notNull(), // จำนวนเงินสุทธิที่จ่าย (หลังหักภาษี)

  // เชื่อมกับ Payment (optional — อาจสร้าง WHT โดยตรงก็ได้)
  paymentId: text("payment_id"), // FK → payments.id

  // ประเภทแบบ — ภ.ง.ด.3 (บุคคลธรรมดา) หรือ ภ.ง.ด.53 (นิติบุคคล)
  formType: text("form_type", {
    enum: ["pnd3", "pnd53"],
  }).notNull(),

  // สถานะ
  status: text("status", {
    enum: ["draft", "submitted", "cancelled"],
  }).notNull().default("draft"),

  remarks: text("remarks"),

  // ข้อมูลสำหรับยื่นภาษี
  taxYear: text("tax_year"),           // ปีภาษี เช่น "2026"
  taxMonth: text("tax_month"),         // เดือนภาษี เช่น "01"-"12"
  whtCondition: text("wht_condition", {
    enum: ["every_time", "one_time"],
  }),  // เงื่อนไขการหัก: หักทุกครั้งที่จ่าย / หักครั้งเดียว

  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type WhtCertificate = typeof whtCertificates.$inferSelect;
export type NewWhtCertificate = typeof whtCertificates.$inferInsert;
